import { defineMessages } from 'react-intl-next';

const _default_1: {
    hubLogo: {
        defaultMessage: string;
        description: string;
        id: string;
    };
    login: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
    hubLogo: {
        id: 'company-hub.hub-app-shell.navbar.hub.logo',
        defaultMessage: 'Support home',
        description: 'The logo of the Hub',
    },
    login: {
        id: 'company-hub.hub-app-shell.navbar.hub.log-in',
        defaultMessage: 'Log in',
        description: 'Log in button label',
    },
});
export default _default_1;
